// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: "1.1.3",
  updateDate: "20/07/2026",
  environmentName: "Dev",
  baseUrl: "https://member.dev.luxengine.com",
  apiBaseUrl: "https://api.dev.luxengine.com",
  assetsServiceUrl:
    "https://assetservice.dev.luxengine.com/api/v1/member-assets",
  sentryDsn: "",
  stripePublishableKey: "pk_test_51Tc18Y1DcF8QbUs16bjOMOpYbijlcUlDbcVh1KgUMmgEICcwNVHee7RmbUGBpO99OrvQKzWbKaNPFKVO49JWcfVW00yETNnCON",
  firebase: {
    apiKey: "AIzaSyAafRnM_10NhpYEsnz32iUQ6_r8nRyS9b8",
    authDomain: "bwrm-dev.firebaseapp.com",
    projectId: "bwrm-dev"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
